// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Yboqf","validationTips":"StatementDescriptor_validationTips__hs0h0"};